
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"#2c2c30","stroke":"#707070","d":"M0 0h24v24H0z","transform":"translate(-2081 -1782)"}})])]),_c('g',{attrs:{"fill":"#2c2c30","clip-path":"url(#a)","transform":"translate(2081 1782)"}},[_c('path',{attrs:{"d":"M-2069.005-1778.755a.905.905 0 00-.669.259.918.918 0 00-.259.679v11.757l.107 2.91.557-.254-3.163-3.515-2.1-2.07a.877.877 0 00-.3-.2.977.977 0 00-.366-.068.865.865 0 00-.645.259.89.89 0 00-.254.649.948.948 0 00.293.674l6.1 6.113a.981.981 0 00.327.234.915.915 0 00.366.078.938.938 0 00.376-.078.981.981 0 00.327-.234l6.1-6.113a.948.948 0 00.293-.674.881.881 0 00-.259-.649.869.869 0 00-.64-.259.977.977 0 00-.366.068.877.877 0 00-.3.2l-2.109 2.07-3.159 3.516.576.254.107-2.91v-11.758a.909.909 0 00-.264-.679.922.922 0 00-.676-.259z"}})])])
          )
        }
      }
    